import {Injectable} from '@angular/core';
import {BreadcrumbLabel} from './breadcrumb';
import {UrlTree} from '@angular/router';
import {ReplaySubject} from 'rxjs/index';

export interface BreadcrumbSnapshot {
    label: BreadcrumbLabel | string;
    urlTree: UrlTree;
}

@Injectable()
export class BreadcrumbService {
    public static readonly breadcrumbChange = new ReplaySubject<BreadcrumbSnapshot>();

    public notifyChange(currentBreadcrumb: BreadcrumbSnapshot) {
        BreadcrumbService.breadcrumbChange.next(currentBreadcrumb);
    }
}